// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-simple-pagination .swiper-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.h-simple-pagination .swiper-pagination-bullet{width:4px;height:4px;margin-right:8px;background:grey;opacity:unset}.h-simple-pagination .swiper-pagination-bullet-active{background:#fff}.h-simple-pagination__img{width:100%;border-radius:3px;aspect-ratio:3/2}", ""]);
// Exports
module.exports = exports;
